//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Badge from './badge.vue';

export default {
  components: { Badge },
  computed: {
    sale() {
      return this.$store.state.sale.sale;
    },
    badgeFirst() {
      if (this.sale.badgeFirst) {
        return this.filterHtml(this.sale.badgeFirst);
      } else {
        return this.$t('sale.badgeFirst');
      }
    },
    badgeSecond() {
      if (this.sale.badgeSecond) {
        return this.filterHtml(this.sale.badgeSecond);
      } else {
        return `${this.$t(
          'sale.badgeSecond.part1',
        )} <span class="highlighted">${this.$t(
          'sale.badgeSecond.part2',
        )}</span>`;
      }
    },
  },
  methods: {
    filterHtml(html) {
      if (html === '<br>') return false;
      return html;
    },
  },
};
